import { useContext, useEffect, useState } from 'react'
import {
// Select,
// Upload,
} from 'antd'
import { rightNavContext } from '@/components/Content/RightNavCtrl/RightNavCtrl'

import RenderKeyValue from '@/components/Content/RenderKeyValue'

import './index.less'

const prefix = 'slopeAnalysisResult'
const headerArr = [{ key: '주소', value: '전주시 덕진구 송전동1가 10-10' }]

const contentArrDefault = [
  { key: '전체면적(㎡)', value: '1889.97' },
  { key: '평균경사도(°)', value: '22.16' },
  { key: '최저경사도 (°)', value: '0.26' },
  { key: '최고경사도 (°)', value: '39.3' },
]

const arr = [
  { range: '10° 미만', color: '#00ff00', area: '', percentage: '' },
  { range: '10°이상 ~ 15°미만', color: '#adff2f', area: '', percentage: '' },
  { range: '15°이상 ~ 20°미만', color: '#9acd32', area: '', percentage: '' },
  { range: '20°이상 ~ 25°미만', color: '#ffff00', area: '', percentage: '' },
  { range: '25°이상 ~ 30°미만', color: '#ffd700', area: '', percentage: '' },
  { range: '30°이상 ~ 35°미만', color: '#ff6347', area: '', percentage: '' },
  { range: '35°이상 ~ 40°미만', color: '#ff0000', area: '', percentage: '' },
  { range: '40°이상', color: '#a52a2a', area: '', percentage: '' },
  { range: '계', color: '', area: '', percentage: '' },
]
function slopeAnalysisResult(props: any) {
  const rightContext = useContext(rightNavContext)
  const { polygonSource8 } = props
  const [contentArr, setContentArr] = useState(contentArrDefault)
  const [contentArr2, setContentArr2] = useState(arr)
  useEffect(() => {
    if (Array.isArray(polygonSource8) && polygonSource8.length > 0) {
      contentArr[0].value = polygonSource8[8].area
      contentArr[1].value = polygonSource8[8].avgDegrees
      contentArr[2].value = polygonSource8[8].minDegress
      contentArr[3].value = polygonSource8[8].maxDegress
      setContentArr(contentArr)
      setContentArr2(polygonSource8)
    }
  }, [polygonSource8])
  const renderContent = () => {
    return contentArr2.map((item, index) => {
      return <ul className={`${prefix}-box2-content-item`} key={index}>
          <li className={`${prefix}-box2-content-item-li`}>{item.range}</li>
          <li className={`${prefix}-box2-content-item-bgc ${prefix}-box2-content-item-li`} style={{ background: item.color }}></li>
          <li className={`${prefix}-box2-content-item-li`}>{item.area}</li>
          <li className={`${prefix}-box2-content-item-li`}>{item.percentage}</li>
        </ul>
    })
  }

  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-box1`}>
        <p>분석결과 개요</p>
        <ul className={`${prefix}-box1-ul`}>
          <li className={`${prefix}-box1-ul-commonLi`}>
            <span className={`${prefix}-box1-ul-key`}>{headerArr[0].key}</span>
            <span className={`${prefix}-box1-ul-value`}>
              {polygonSource8 ? polygonSource8[8].position : ''}
            </span>
          </li>
          <div className={`${prefix}-box1-ul-box`}>
            <RenderKeyValue contentArr={contentArr} />
          </div>
        </ul>
      </div>
      <div className={`${prefix}-box2`}>
        <p>상세 분석결과</p>
        <ul className={`${prefix}-box2-header`}>
          <li>구분</li>
          <li>색상표</li>
          <li>면적(㎡)</li>
          <li>구성비(%)</li>
        </ul>
        <ul className={`${prefix}-box2-content`}>{renderContent()}</ul>
      </div>
    </div>
  )
}
export default slopeAnalysisResult
